import { api } from "./api";

export const listClasses = async (params: {
  startDate?: Date;
  endDate?: Date;
  fightsId?: string;
}): Promise<any> => {
  const { data } = await api.get("classes", { params });
  return data;
};

export const getClassesById = async (id: string | number): Promise<any> => {
  const { data } = await api.get("classes/" + id);
  return data;
};

export const classesIndicators = async (params: {
  startDate?: Date;
  endDate?: Date;
}): Promise<any> => {
  const { data } = await api.get("classes/indicators", { params });
  return data;
};

export const classesCadaster = async (body: {
  startTime: Date;
  endTime: Date;
  date: Date;
  name: string;
  description?: string;
  fightsId?: string;
  spacesId?: string;
  professorId?: string[];
  automaticCompletion?: boolean;
}): Promise<any> => {
  const { data } = await api.post("classes/cadaster", body);
  return data;
};

export const classesUpdate = async (body: {
  id: string;
  startTime: Date;
  endTime: Date;
  date: Date;
  name: string;
  description?: string;
  fightsId?: string;
  spacesId?: string;
  professorId?: string[];
  automaticCompletion?: boolean;
}): Promise<any> => {
  const { data } = await api.put("classes/update", body);
  return data;
};

export const classesConfirm = async (body: unknown): Promise<any> => {
  const { data } = await api.post("classes/confirm", body);
  return data;
};

export const classesCheckInStore = async (body: unknown): Promise<any> => {
  const { data } = await api.post("classes/check-in/store", body);
  return data;
};

export const removeCheckIn = async (
  classesId: number,
  body: { studentId: number | null }
): Promise<any> => {
  const { data } = await api.delete(`classes/remove/${classesId}`, {
    data: body,
  });
  return data;
};
